/** In-memory refresh token — never persisted to localStorage/sessionStorage. */
let refreshToken: string | null = null;

export const refreshTokenStore = {
  get(): string | null {
    return refreshToken;
  },
  set(token: string | null): void {
    refreshToken = token?.trim() || null;
  },
  clear(): void {
    refreshToken = null;
  },
};
